import { createSelector, lruMemoize } from '@reduxjs/toolkit'
import format from 'date-fns/format'

// eslint-disable-next-line import/no-cycle -- legacy cycle via providers/store; out of scope to refactor here
import { getUserInfo } from 'data/userInfo/userInfoSelectors'
import { FRONTEND_DATE_FORMAT_DATE_FNS, FRONTEND_TIME_FORMAT_DATE_FNS, FRONTEND_ZONE_FORMAT_DATE_FNS } from 'settings/constants/date'
import { TIME_ZONES_SHORT_FORM } from 'settings/constants/timeZones'
import { getLocalDate } from 'utils/date'
import { get } from 'utils/lodash'
import { convertTimeToTimezone } from 'utils/timezoneDate'

const EMPTY_RESPONSE = { fullDateTime: '', onlyDate: '', onlyTime: '', DSTZone: '', zone: '' }

const selectDateTime = state => get(state, 'dateTime', '')
const selectDefaultZone = state => get(state, 'defaultZone', '')
const selectDefaultDateFormat = state => get(state, 'defaultDateFormat', FRONTEND_DATE_FORMAT_DATE_FNS)
const selectDefaultTimeFormat = state => get(state, 'defaultTimeFormat', FRONTEND_TIME_FORMAT_DATE_FNS)

export const convertDateTimeToPreferedTimezone = createSelector(
  [selectDateTime, selectDefaultZone, selectDefaultDateFormat, selectDefaultTimeFormat],
  (dateTime, defaultZone, defaultDateFormat, defaultTimeFormat) => {
    try {
      if (!dateTime) {
        return { ...EMPTY_RESPONSE }
      }

      const defaultDateTimeFormat = `${defaultDateFormat} ${defaultTimeFormat}`
      const userTimeZone = get(getUserInfo(), 'timeZone', defaultZone)

      // Don't include zone here, calculate zone separately
      const convertToUserTimeZone = userTimeZone
        ? convertTimeToTimezone(dateTime, defaultDateTimeFormat, userTimeZone)
        : getLocalDate(dateTime)
      const convertToDate = new Date(convertToUserTimeZone)

      return {
        fullDateTime: userTimeZone ? convertToUserTimeZone : format(convertToDate, defaultDateTimeFormat, { timezone: userTimeZone }),
        onlyDate: format(convertToDate, defaultDateFormat, { timezone: userTimeZone }),
        onlyTime: format(convertToDate, defaultTimeFormat, { timezone: userTimeZone }),
        DSTZone: userTimeZone ? convertTimeToTimezone(dateTime, FRONTEND_ZONE_FORMAT_DATE_FNS, userTimeZone) : '',
        zone: get(TIME_ZONES_SHORT_FORM, userTimeZone, ''),
      }
    } catch (err) {
      return { ...EMPTY_RESPONSE }
    }
  },
  // Reads the user's zone outside its inputs, so it keeps reselect 4's one-entry cache instead of remembering every time.
  { memoize: lruMemoize, argsMemoize: lruMemoize }
)
